"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textButtonStyles = exports.SUBMENU_CLOSE_CLASSNAME = exports.SUBMENU_STAY_OPEN_CLASSNAME = exports.DEBOUNCE_TIMEOUT = exports.toolbarI18nKey = exports.TOOLBAR_I18N_PREFIX = exports.controlPropType = exports.ToolbarControlMargins = exports.MenuTypes = exports.ToolbarControlTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("HubStyleTokens/colors");

var ToolbarControlTypes = {
  BUTTON: 'BUTTON',
  SELECT: 'SELECT',
  DIVIDER: 'DIVIDER',
  MORE_MENU: 'MORE_MENU',
  ADVANCED_MENU: 'ADVANCED_MENU',
  INSERT_MENU: 'INSERT_MENU'
};
exports.ToolbarControlTypes = ToolbarControlTypes;
var MenuTypes = [ToolbarControlTypes.ADVANCED_MENU, ToolbarControlTypes.INSERT_MENU, ToolbarControlTypes.MORE_MENU];
exports.MenuTypes = MenuTypes;
var ToolbarControlMargins = {
  DEFAULT: 8,
  BUTTON: 2,
  ZERO: 0
};
exports.ToolbarControlMargins = ToolbarControlMargins;

var controlPropType = _propTypes.default.shape({
  type: _propTypes.default.oneOf(Object.keys(ToolbarControlTypes)).isRequired,
  control: _propTypes.default.string
});

exports.controlPropType = controlPropType;
var TOOLBAR_I18N_PREFIX = 'RichTextLib.toolbar';
exports.TOOLBAR_I18N_PREFIX = TOOLBAR_I18N_PREFIX;

var toolbarI18nKey = function toolbarI18nKey(suffix) {
  return TOOLBAR_I18N_PREFIX + "." + suffix;
};

exports.toolbarI18nKey = toolbarI18nKey;
var DEBOUNCE_TIMEOUT = 500;
exports.DEBOUNCE_TIMEOUT = DEBOUNCE_TIMEOUT;
var SUBMENU_STAY_OPEN_CLASSNAME = 'mce-submenu-item--open';
exports.SUBMENU_STAY_OPEN_CLASSNAME = SUBMENU_STAY_OPEN_CLASSNAME;
var SUBMENU_CLOSE_CLASSNAME = 'mce-submenu-item--close';
exports.SUBMENU_CLOSE_CLASSNAME = SUBMENU_CLOSE_CLASSNAME;
var textButtonStyles = "\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n  font-size: 13px !important;\n  margin-bottom: 1px !important;\n  color: " + _colors.CALYPSO_DARK + " !important;\n";
exports.textButtonStyles = textButtonStyles;